<template>
  <div class="member_list" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="memberCode" placeholder="搜索会员码" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      <el-input class="s_input" v-model="memberTel" placeholder="搜索手机号码" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="memberName" label="会员名称"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="150" prop="memberCode" label="会员码"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="memberTel" label="手机号码"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="balance" label="账户余额(元)"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button class="btn" type="primary" plain @click="viewRecords(1, scope.row)">账单明细</el-button>
            <el-button class="btn" type="primary" plain @click="viewRecords(2, scope.row)">充值记录</el-button>
            <el-button class="btn" type="primary" plain @click="viewRecords(3, scope.row)">已购项目</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      memberCode: "",
      memberTel: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.memberInfopageList, {
          params: {
            memberTel: this.memberTel,
            memberCode: this.memberCode,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list || []
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    viewRecords(e, row) {
      let str = e == 1 ? "/marketing/member/detail/bill" : e == 2 ? "/marketing/member/recharge" : "/marketing/member/detail/memberDetail"
      this.$router.push({ path: str, query: { id: row.userId, code: row.memberCode } })
    },
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss">
.member_list {
  .search {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 44px;
    margin-bottom: 20px;

    .el-input {
      width: 200px;

      ::v-deep .el-input__inner {
        border-radius: 10px;
      }
    }

    .el-input,
    .el-select,
    .el-button {
      margin-left: 20px;
    }
  }
}
</style>
